
import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges, HostListener } from '@angular/core';

@Directive({
  selector: '[appDisableWhile]'
})
export class DisableWhileDirective implements OnChanges {
  @Input('appDisableWhile') isPending: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.setDisabledState(this.isPending);
  }

  private setDisabledState(disabled: boolean): void {
    if (disabled) {
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
  }

  @HostListener('click', ['$event'])
  handleClick(event: Event) {
    console.log(`Click event handler...`)
    if (this.isPending) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
}
